import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { EntityManagerProvider } from './entity-manager-provider.service';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

@Injectable()
export class PrepareGuard implements CanActivate {
    constructor(private entityManagerProvider: EntityManagerProvider, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.entityManagerProvider.prepare()
            .then(() => true)
            .catch(e => {
                if (e.status == 401) {
                    this.router.navigate(['/login']);
                    return false;
                }

                // Something else happened
                throw e;
            });
    }
}

